module.exports = __webpack_public_path__ + "img/post-thumb-5.33a33562.png";